module.exports = __webpack_public_path__ + "static/img/3-5-aftersale-detail.d188327.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/jushuitan/3-5-aftersale-detail.png
// module id = 1326
// module chunks = 0